<template>
  <div>
    <!--<m-billing :isShow= "showBillingInfo" v-on:close="showBillingInfo = false"></m-billing>-->

    <div @click = "showBillingInfo = true">open</div>
  </div>
</template>

<script>
  // import MBilling from '@/components/summary/MBilling'
  // import utils from '@/assets/utils.js'

  export default {
    name: 'test',
    components: {
      // MBilling
    },
    data () {
      return {
        showBillingInfo: true
      }
    },
    created () {
    },
    methods: {
    },
    computed: {
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/testSummary.vue